<app-info-panel>
  <h3>Welcome to the Building Review Insights</h3>
</app-info-panel>
<section>
  <h4>To generate your first building review, select the building from the button above left labelled "Select Building"</h4>
</section>
